import { Box, Button, IconButton, Modal, Typography } from '@mui/material';
import { useFormik } from 'formik';
import React, { useState } from 'react';
import * as Yup from 'yup';
import CloseIcon from '@mui/icons-material/Close';
import SuccessModal from '../successModal/SuccessModal';
import VideoUploadField from '../CommonTextField/VideoUploadField';
import { updateCustomerReviewVideo } from '../../services/CustomerReviewVideo';
import { useMediaQueries } from '../../usecontext/UseProvider';

const validationSchema = Yup.object({
    video: Yup.mixed()
        .required('The Video field is required.'),
});

const HappyCustomerModal = ({ open, setOpen, videoData, onUpdateSuccess }) => {
    const [successModalOpen, setSuccessModalOpen] = useState(false);
    const [error, setError] = useState('');
    const { setLoading } = useMediaQueries();

    

    const formik = useFormik({
        initialValues: {
            video: null,
        },
        validationSchema,
        onSubmit: async (values) => {
            try {
                setLoading(true);
                setError('');
                const formData = new FormData();
                formData.append('video', values.video);

                const response = await updateCustomerReviewVideo(formData, videoData?._id);
                
                if (response?.error) {
                    setError(response.error);
                } else {
                    setOpen(false);
                    setSuccessModalOpen(true);
                    formik.resetForm();
                    onUpdateSuccess?.();
                }
            } catch (error) {
                setError('Something went wrong. Please try again.');
                console.error('Error updating video:', error);
            } finally {
                setLoading(false);
            }
        },
    });

    const handleClose = () => {
        setOpen(false);
        formik.resetForm();
        setError('');
    };

    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-happay-customer"
                aria-describedby="modal-description"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 3,
                        borderRadius: 2,
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #D5D5D5' }}>
                        <Typography id="modal-happy-customer" variant="h5" sx={{ mb: 2 }}>
                            Change Video
                        </Typography>
                        <IconButton onClick={handleClose} sx={{ p: 0, '&:hover': { backgroundColor: 'transparent' } }} disableRipple disableFocusRipple >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <form onSubmit={formik.handleSubmit} style={{ padding: '10px' }}>
                        <VideoUploadField label="Video" name="video" formik={formik} />

                        {error && (
                            <Typography color="error" variant='caption'>{error}</Typography>
                        )}
                        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 3, mt: 4 }}>
                            <Button
                                variant="outlined"
                                sx={{
                                    borderRadius: '10px',
                                    borderColor: '#01A0E2',
                                    color: '#000',
                                    width: '150px',
                                    textTransform: 'none'
                                }}
                                onClick={handleClose}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="submit"
                                variant="contained"
                                sx={{
                                    borderRadius: '10px',
                                    backgroundColor: '#01A0E2',
                                    color: '#fff',
                                    width: '150px',
                                    textTransform: 'none'
                                }}
                            >
                                Update
                            </Button>
                        </Box>
                    </form>
                </Box>
            </Modal>

            {/* Success Modal */}
            <SuccessModal
                open={successModalOpen}
                onClose={() => setSuccessModalOpen(false)}
                message='Happy customer video updated successfully'
            />
        </div>
    )
}

export default HappyCustomerModal
